module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper career-page-wrapper expert-page-wrapper",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.showWatchVideoModal) ? _c('modal', {
    staticClass: "watchVideoModal",
    attrs: {
      "effect": "zoom",
      "value": _vm.showWatchVideoModal
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('div', {
    staticClass: "watchVideoModalHeader",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "alt": "LOGO"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.cancelModal()
      }
    }
  }, [_c('img', {
    staticClass: "watchVideoArrow",
    attrs: {
      "src": require("../assets/watch-video-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('jwplayer', {
    attrs: {
      "data": _vm.currentPlayerID
    }
  }, [_vm._v("Loading the player...")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.currentPlayerID.videoDescription) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured main"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row margin-top-40"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "https://s3.amazonaws.com/assets.tonenetworks.com/images/experts/Ramani.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "experts"
  }, [_c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/#/expert/19"
    }
  }, [_c('h2', [_vm._v(" Dr. Ramani Durvasula ")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(" (Relationship Realist, Ph.D.) ")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("Dr. Ramani Durvasula is a licensed clinical psychologist in private practice and Professor of Psychology at California State University, Los Angeles, where she was named Outstanding Professor in 2012. She is also a Visiting Professor at the University of Johannesburg. She brings a wealth of expertise in relationships, sexuality, health and wellness, helping people reach their full potential in their relationships, jobs, and family time. "), _c('br'), _vm._v("\n                                Dr. Ramani is a sought-after presenter for audiences ranging from adolescents to mental health professionals. She is involved in national governance in the field of psychology and served as chair of the Committee on Socioeconomic Status at the American Psychological Association and is a member of the Advisory Board of the Minority Fellowship Program of the American Psychological Association."), _c('br'), _vm._v("\n                                Dr. Ramani was co-host of Oxygen’s "), _c('i', [_vm._v("My Shopping Addiction")]), _vm._v(", and has been featured on Bravo, Lifetime Movie Network, National Geographic, History Channel, Discovery, and in documentary films on health. She is a featured commentator on nearly every major television network, radio, print, and internet media. She is the author of numerous peer-reviewed journal articles, book chapters and papers; the modern relationship survival manual "), _c('i', [_vm._v("Should I Stay or Should I Go: Surviving a Relationship With a Narcissist")]), _vm._v("; and "), _c('i', [_vm._v("You Are WHY You Eat: Change Your Food Attitude, Change Your Life")]), _vm._v(". Dr. Ramani is currently at work on a new book about staying sane in our era of entitlement. ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-top-40"
  }, [_c('div', {
    staticClass: "blog-section videossection clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 margin-bottom-40"
  }, [_c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/#/expert/19"
    }
  }, [_c('h2', {
    staticClass: "text-center pinkh2"
  }, [_vm._v("CLICK HERE FOR MORE ON Dr. Ramani Durvasula")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.tonenetworks.com/#/expert/19"
    }
  }, [_c('div', {
    staticClass: "row random-section-head yourFaves exceptionalsettings"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": "https://cdn.jwplayer.com/thumbs/dWIRniaI-720.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v("Retail Therapy")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": "https://cdn.jwplayer.com/thumbs/tTLW0ntx-720.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v("How to Pick a Partner")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": "https://cdn.jwplayer.com/thumbs/m0jB57uy-720.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v("Channel Your Inner Leader")])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4572d5bb", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4572d5bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/DrRamani.vue